import { Mapper } from "../types";

var largeZIndex = 1000;

var defaultIcon = {
  iconUrl: "img/dot_black.svg",
  iconSize: [10, 10],
  iconAnchor: [5, 5],
};

var defaultHomeIcon = {
  iconUrl: "img/dot_black.svg",
  iconSize: [10, 10],
  iconAnchor: [5, 5],
};

var defaultOriginIcon = defaultIcon;

var defaultOppositeIcon = defaultIcon;

var defaultDirectIcon = {
  iconUrl: "/images/svg/odotsvg.aspx?colors=EEEEEE,AA3333&rad=.85", //'img/dot_red.svg',
  iconSize: [10, 10],
  iconAnchor: [5, 5],
};

var defaultConnectionIcon = {
  iconUrl: "/images/svg/odotsvg.aspx?colors=EEEEEE,2255BB&rad=.85", //'img/dot_blue.svg',
  iconSize: [10, 10],
  iconAnchor: [5, 5],
};

export const MapperDefault: Mapper = {
  includeBookingLink: false,
  bookingLink: {
    url: null,
    urlDomestic: null,
    urlIntl: null,
    domesticCountryCode: null,
    parameters: {},
    formats: {
      dateFormat: null,
      departureDateFormat: null,
      departureTimeFormat: null,
      arrivalDateFormat: null,
      arrivalTimeFormat: null,
    },
    summaryLegUrl: null,
    detailLegUrl: null,
    target: null,
  },
  includeAirlineLinks: false,
  validationType: null,
  defaultIcon: defaultIcon,
  defaultHomeIcon: defaultHomeIcon,
  defaultOriginIcon: defaultOriginIcon,
  defaultOppositeIcon: defaultOppositeIcon,
  defaultDirectIcon: defaultDirectIcon,
  defaultConnectionIcon: defaultConnectionIcon,
  getHomeIcon: function () {
    if (!!this.homeIconOverride) return this.homeIconOverride;
    return this.defaultHomeIcon;
  },
  getOriginIcon: function () {
    if (!!this.originIconOverride) return this.originIconOverride;
    return this.defaultOriginIcon;
  },
  getOppositeIcon: function () {
    if (!!this.oppositeIconOverride) return this.oppositeIconOverride;
    return this.defaultOppositeIcon;
  },
  getDirectIcon: function () {
    if (!!this.directIconOverride) return this.directIconOverride;
    return this.defaultDirectIcon;
  },
  //getDirectIcon:function(){ var ret = this._getDirectIcon() ; console.log( "directI:%o", ret ) ; return ret ; },
  getConnectionIcon: function () {
    if (!!this.connectionIconOverride) return this.connectionIconOverride;
    return this.defaultConnectionIcon;
  },
  startUpPoints: [],
  startUpPointsConnections: [],
  selectedDirectMarkers: [],
  selectedConnectionMarkers: [],
  originPort: "***",
  nonStopDirectMap: false,
  stopsAreConnections: true,
  intialiseStartUpPoints: {
    directs: true,
    connections: true,
    autoZoomMode: "connections",
    daysToLookForward: 7,
    panToAirport: true,
  },
  openWithFocusOnWhereWeFlyTo: false,
  showStarBurst: true,
  lockOrigin: false,
  lockDestination: false,
  allowSameDestination: true,
  showVia: false,
  lockFormViaDirection: false,
  enableLowCostIndicator: true,
  displayDateFormat: "HH:mm",
  codeShareCarrierList: "",
  flightFinder: {
    directs: {
      enable: true,
      carrier1Criteria: null,
      carrier2Criteria: null,
      carrier3Criteria: null,
      prefferedCarrier: null,
      preferredCarrierCriteria: null,
      originCriteria: null,
      destinationCriteria: null,
      viaCriteria: null,
    },
    connections: {
      enable: true,
      carrier1Criteria: null,
      carrier2Criteria: null,
      carrier3Criteria: null,
      prefferedCarrier: null,
      preferredCarrierCriteria: null,
      originCriteria: null,
      destinationCriteria: null,
      viaCriteria: null,
    },
    details: {
      enable: true,
    },
  },
  showPolyLines: true,
  directIconStyle: {
    "circle-radius": 4,
    "circle-color": "#AA3333",
    "circle-stroke-color": "white",
    "circle-stroke-width": 1,
  },
  connectionIconStyle: {
    "circle-radius": 4,
    "circle-color": "#2255BB",
    "circle-stroke-color": "white",
    "circle-stroke-width": 1,
  },
  homeIconStyle: {
    "circle-radius": 4,
    "circle-color": "#000000",
    "circle-stroke-color": "white",
    "circle-stroke-width": 1,
  },
  polyLineDefaults: {
    strokeColor: "#8AB920",
    strokeWeight: 1,
    strokeOpacity: 1.0,
    static: true,
    visible: false,
    editable: false,
    draggable: false,
    geodesic: true,
    zIndex: largeZIndex + 10,
  },
  polyLineConnectionDefaults: {
    strokeColor: "#0064A3",
    strokeWeight: 1,
    strokeOpacity: 1.0,
    static: true,
    visible: false,
    editable: false,
    draggable: false,
    geodesic: true,
    zIndex: largeZIndex + 9,
  },
  autocomplete: {
    searchType: 4,
    filter: {
      carrier: null,
      port: null,
    },
    initOriginAutoComplete: false,
    initDestinationAutoComplete: false,
  },
  ajaxStatus: {
    started: 0,
    completed: 1,
  },
  require: {
    carrier: true,
    from: true,
    to: true,
  },
  carriersList: [],
  getCarriersList: function () {
    return this.carriersList;
  },
  getCarriersCommaDelimitedList: function () {
    var t = "";

    for (var i = 0; i < this.carriersList.length; i++) {
      t += this.carriersList[i].code + ",";
    }

    return t.substring(0, t.length - 1);
  },
  googlIconConfigFor: function (url) {
    return { iconUrl: url, iconSize: [10, 10], iconAnchor: [5, 5] };
  },
  googlize: function () {
    this.defaultHomeIcon = this.googlIconConfigFor("img/departure-point.png");
    this.defaultOriginIcon = this.defaultHomeIcon;
    this.defaultOppositeIcon = this.defaultHomeIcon;
    this.defaultDirectIcon = this.googlIconConfigFor(
      "img/direct-selected-point.png"
    );
    this.defaultConnectionIcon = this.googlIconConfigFor(
      "img/connection-selected-point.png"
    );
  },
};
